<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--PWA 정보-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001176') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--PWA No.-->
							<th class="col-1">PWA No.</th>
							<td class="col-1">
								<el-input
									v-model="pwaNo"
									:readonly="roApcnPopUp.readOnlyAuth1"
									@keyup.native.delete="ondeletePwaNo()"
									maxlength="20"
									@change="ondeletePwaNo"
								></el-input>
								<i class="icon-sf-search search-icon2" @click="() => onPwaApcnPopup()"></i>
							</td>
							<!--처리단계-->
							<th class="col-1">{{ getMessage_('QWCC000963') }}</th>
							<td class="col-1">
								<el-input v-model="prcsStepNm" readonly />
							</td>
							<!--신청일-->
							<th class="col-1">{{ getMessage_('QWCC000979') }}</th>

							<td class="col-1">
								<el-input v-model="aplcDd" readonly />
							</td>
							<!--확정일-->
							<th class="col-1">{{ getMessage_('QWCC000980') }}</th>
							<td class="col-1">
								<el-input v-model="dcsnDd" readonly />
							</td>

							<!--pwa 신청자-->
							<th class="col-1">{{ getMessage_('QWCC002089') }}</th>
							<td class="col-1">
								<el-input v-model="aplcNm" readOnly />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import moment from 'moment';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			pwaNo: '', //pwqNo
			prcsStepNm: '',
			prcStep: '',
			aplcDd: '',
			dcsnDd: '',
			pwaNoInput: '' //팝업
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setProcessInfo() {
			this.pwaNo = this.roApcnPopUp.pwaNo; // PWANO
			this.prcStep = this.roApcnPopUp.prcStep; //처리단계코드
			this.prcsStepNm = this.roApcnPopUp.prcsStepNm; // 처리단계명
			this.aplcDd = this.roApcnPopUp.aplcDd; //신청일
			this.dcsnDd = this.roApcnPopUp.dcsnDd; //확정일 
			this.aplcNm = this.roApcnPopUp.aplcNm; //신청자
		},
		/*******************************************얼그레이아이스티 ******************************/
		//PWA 목록 팝업
		async onPwaApcnPopup() {
			//
			if (!this.roApcnPopUp.readOnlyAuth1) {
				const pwaNo = this.pwaNo;
				this.setState_({ key: 'isDelPwaCompInitFlag', value: false });
				await this.$emit('OpenPwaApcnPopup', pwaNo);
			}
		},
		ondeletePwaNo() {
			if (!this.roApcnPopUp.readOnlyAuth1) {
				this.pwaNo = '';
				this.prcsStepNm = '';
				this.aplcDd = '';
				this.dcsnDd = '';
				this.prcStep = '';

				this.setStateRoApcnPopup_({ key: 'pwaNo', value: '' });

				this.setState_({ key: 'isDelPwaCompInitFlag', value: true });
				//각 컴포넌트 disable풀기
				this.setStateRoApcnPopup_({ key: 'readOnlyAuth', value: false });

				this.setState_({ key: 'roApcnSwapPartsList', value: [] });
			}
		},
		ondeletePwaNo2() {
			if (!this.roApcnPopUp.readOnlyAuth1) {
				this.pwaNo = '';
				this.prcsStepNm = '';
				this.aplcDd = '';
				this.dcsnDd = '';
				this.prcStep = '';

				this.setStateRoApcnPopup_({ key: 'pwaNo', value: '' });

				//this.setState_({ key: 'isDelPwaCompInitFlag', value: true });
				//각 컴포넌트 disable풀기
				this.setStateRoApcnPopup_({ key: 'readOnlyAuth', value: false });

				this.setState_({ key: 'roApcnSwapPartsList', value: [] });
			}
		}
	},
	/*******************************************얼그레이아이스티 ******************************/
	async created() {
		//스토어에서 값을 가져와서 셋팅한다.

		this.pwaNo = this.roApcnPopUp.pwaNo; // PWANO
		this.prcStep = this.roApcnPopUp.prcStep; //처리단계코드
		this.prcsStepNm = this.roApcnPopUp.prcsStepNm; // 처리단계명
		this.aplcDd = this.roApcnPopUp.aplcDd; //신청일
		this.dcsnDd = this.roApcnPopUp.dcsnDd; //확정일
		this.aplcNm = this.roApcnPopUp.aplcNm; //신청자
	},
	watch: {
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateApcnSave_({ key: 'pwaNo', value: convertNvl(this.pwaNo, '') }); // PWANO
				this.setStateApcnSave_({ key: 'prcStep', value: convertNvl(this.prcStep, '') }); //처리단계코드
				this.setStateApcnSave_({ key: 'prcsStepNm', value: convertNvl(this.prcsStepNm, '') }); // 처리단계명
				this.setStateApcnSave_({ key: 'aplcNm', value: convertNvl(this.aplcNm, '') }); // 신청자
				//this.setStateApcnSave_({ key: 'aplcDd', value: moment(convertNvl(this.aplcDd, '')).format('YYYYMMDD') }); //신청일
				//this.setStateApcnSave_({ key: 'dcsnDd', value: moment(convertNvl(this.dcsnDd, '')).format('YYYYMMDD') }); //확정일
			}
		},
		//삭제Flag
		isDelCamPaignCompInitFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.isDelCamPaignCompInitFlag) {
				this.pwaNo = '';
				this.prcsStepNm = '';
				this.prcStep = '';
				this.aplcDd = '';
				this.dcsnDd = '';
			}
		}
	}
};
</script>
<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon2 {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: 3px;
}
</style>
